import knAxios from "@/lib/kn-axios.js";

const PaymentsRemoteDataSource = {
  getPaymentTypes: () => knAxios.get("/paymentTypes"),

  getRelativeBalanceInformation: () => knAxios.get("/payments/balance/getInfo"),

  getRelativeInvoiceInfo: (idRelative) =>
    knAxios.get(`/invoiceInfos/tutorInfo/${idRelative}`),

  openPayPayment: (idPaymentType, idRelative, request) =>
    knAxios.post(
      `/payments/paymentMethod/${idPaymentType}/idRelative/${idRelative}/openPay`,
      request
    ),

  banortePayment: (idPaymentType, idRelative, request) =>
    knAxios.post(
      `/payments/paymentMethod/${idPaymentType}/idRelative/${idRelative}/banorte?isEditInWizard=false`,
      request
    ),

  confirm3dSecure: (idPayment, request) => {
    const { data } = knAxios.post(
      `/payments/idPayment/${idPayment}/banorte/3DSecure/confirmation`,
      request
    );
    return data;
  },

  openpay3dSecure: (idRelative, token, request) => {
    return knAxios.post(
      `/payments/paymentMethod/${request.idPaymentType}/idRelative/${idRelative}/openPay/3DSecure?isEditInWizard=false&access_token=${token}`,
      request
    );
  },

  confirmOpenpay3dSecure: (idPayment) => {
    const data = knAxios.get(
      `/payments/idPayment/${idPayment}/openPay/3DSecure/confirmation`
    );
    return data;
  },

  getMonthlyPayments: (idPaymentType, request) =>
    knAxios.post(
      `/payments/getMonthlyPayments/idPaymentMethod/${idPaymentType}`,
      request
    ),

  getPaymentBankTransferInfo: (
    idPaymentType,
    idRelative,
    request,
    cvv = "null"
  ) =>
    knAxios.post(
      `/payments/bank/getInfo/${idPaymentType}/idRelative/${idRelative}/cvv/${cvv}`,
      request
    ),

  getOxxoPaymentInfo: (idPaymentType, idRelative, request) =>
    knAxios.post(
      `/payments/paymentMethod/${idPaymentType}/idRelative/${idRelative}/oxxoPay`,
      request
    ),

  getInfoOxxoPayment: (idPayment, idRelative, request) =>
    knAxios.post(
      `/payments/getInfoOxxo/idPayment/${idPayment}/idRelative/${idRelative}`,
      request
    ),
};

export default PaymentsRemoteDataSource;
